<template>
  <div class='animated fadeIn'>
    <div class='container'>
      <b-card class='shadow-sm p-3 mb-2 bg-white rounded' title='利用規約'>
        <b-card-header header-bg-variant='white'>
          このウェブサイト（以下「当サービス」といいます）は<a href='http://freewill.education'>（株）Freewill トータルエデュケーション</a>が運営しております。お客様が当サービスをご利用されるにあたっては、以下の利用規約をお読み頂き、同意される場合にのみご利用下さい。なお、本規約につきましては予告なく変更することがありますので、あらかじめ御了承下さい。
          </b-card-header>
            <b-list-group flush>
              <b-list-group-item>
第1条【サービス】<br>
1．当サービスの利用に際してはウェブにアクセスする必要がありますが、利用者は自らの費用と責任に必要な機器・ソフトウェア・通信手段等を用意し適切に接続・操作することとします。<br>
2．当サービスではセルフマネジメントに関するサービスの提供を行っておりますが、将来、様々なサービスを追加したり、または変更・削除することがあります<br>
3．弊社は、当サービスが提供及び付随するサービスに対する保証行為を一切しておりません。また、弊社は、当サービスの提供するサービスの不確実性・サービス停止等に起因する利用者への損害について、一切責任を負わないものとします。詳細については、「免責事項について」をご覧下さい。<br>
<br>
第2条【個人情報の取り扱い】<br>
当サービスの利用に際して利用者から取得した氏名、メールアドレス等の個人情報は、別途定める「<router-link to='/Privacy'>プライバシーポリシー</router-link>」に則り取り扱われます。<br>
<br>
第3条【著作権等知的財産権】<br>
1. 当サービス内のプログラム、写真その他の知的財産権は弊社に帰属します。利用者は、当該情報を私用目的で利用される場合にかぎり使用できます。弊社に無断で、それを越えて、使用（複製、送信、譲渡、二次利用等を含む）することは禁じます。<br>
2. 当サービス内の商標は、当該商標権を有する団体に帰属しますので、無断で使用することはできません。<br>
<br>
第4条【禁止事項】<br>
1. 弊社は、利用者が以下の行為を行うことを禁じます。<br>
（1） 弊社または第三者に損害を与える行為、または損害を与える恐れのある行為<br>
（2） 弊社または第三者の財産、名誉、プライバシー等を侵害する行為、または侵害する恐れのある行為<br>
（3） 公序良俗に反する行為、またはその恐れのある行為<br>
（4） 他人のメールアドレスを登録するなど、虚偽の申告、届出を行う行為<br>
（5） コンピュータウィルス等有害なプログラムを使用または提供する行為
（6） 迷惑メールやメールマガジン等を一方的に送付する行為<br>
（7） その他、法令に違反する行為、またはその恐れがある行為<br>
（8） その他弊社が不適切と判断する行為<br>
<br>
2. 上記に違反した場合、弊社は利用者に対し損害賠償請求をすることができることに利用者は同意します。<br>
<br>
第5条【免責事項】<br>
1. 弊社は、当サービスに掲載されている全ての情報を慎重に作成し、また管理しますが、その正確性および完全性などに関して、いかなる保証もするものではありません。<br>
2. 弊社は、予告なしに、本サービスの運営を停止または中止し、また本サービスに掲載されている情報の全部または一部を変更する場合があります。<br>
3. 利用者が当サービスを利用したこと、または何らかの原因によりこれをご利用できなかったことにより生じる一切の損害および第三者によるデータの書き込み、不正なアクセス、発言、メールの送信等に関して生じる一切の損害について、弊社は、何ら責任を負うものではありません。<br>
<br>
第6条【契約解除】<br>
1. 弊社は、利用者が本規約に反する行為をした場合、即時にサービスを停止することができます。<br>
2. 前項の事由が発生したとき、弊社は利用者に損害賠償をすることができます。<br>
<br>
第7条【損害賠償】<br>
本規約に違反した場合、弊社に発生した損害を賠償していただきます。<br>
<br>
第8条【管轄裁判所】<br>
万が一裁判所での争いとなったときは、東京地方裁判所を第一審の専属管轄裁判所とします。<br>
<br>
第9条【特例】<br>
1. 本規約に基づき、特別の規定が別途定められている場合があります。<br>
2. 弊社の各サービスの説明のページに当規約と相反する規定があった場合は、各サービスの説明ページに記載してある規定を適用します。<br>
<br>
（附則）<br>
本規約は、2018年9月23日より施行致します。<br>
<br>
2018年09月23日制定<br>
            </b-list-group-item>
          </b-list-group>
        <b-card-footer footer-bg-variant='white'>
          <b-button @click='goBack'>Back</b-button>
        </b-card-footer>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Terms',
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Terms.vue